/**
 * The fade between the whole tank and a habitat's own scene (M110, the user's third brief, section 8: "Do not animate
 * the camera traveling down the enormous cross-sectional model when switching into a habitat. Use a short visual
 * transition, such as fading through underwater blue. Approximately 0.4–0.8 seconds is a reasonable initial target"):
 * the view covered in the water's blue over `inS`, the scenes swapped behind it, and uncovered over `outS` (JUDGED,
 * 0.55 s in all). A choice made while it is covered takes the place of the one before.
 */
export const VEIL = { inS: 0.22, outS: 0.33 } as const;

export class Veil {
  private readonly el: HTMLElement;
  private pending: ReturnType<typeof setTimeout> | null = null;

  constructor(over: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'veil';
    over.appendChild(this.el);
  }

  /** Covers the view, runs `swap` once it is covered, then uncovers it. */
  through(swap: () => void): void {
    if (this.pending !== null) clearTimeout(this.pending);
    this.el.style.transition = `opacity ${VEIL.inS}s ease-in`;
    this.el.style.opacity = '1';
    this.pending = setTimeout(() => {
      this.pending = null;
      swap();
      this.el.style.transition = `opacity ${VEIL.outS}s ease-out`;
      this.el.style.opacity = '0';
    }, VEIL.inS * 1000);
  }

  /** Whether a swap is waiting for the view to be covered. */
  covering(): boolean {
    return this.pending !== null;
  }
}
